module.exports = __webpack_public_path__ + "static/media/self-defense.4f19423c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/customer-logos/self-defense.png
// module id = 163
// module chunks = 0